import { formatISO } from 'date-fns';
import { GraphData } from 'entities/GraphData';
import { MetricTypeEnum } from 'enums/MetricTypeEnum';
import { apiMetrics } from 'services/apiMetrics';

interface GetMetricValuesByRangeProps {
  patientId: string;
  metricType: MetricTypeEnum;
  startDate: Date;
  endDate: Date;
}

export const getMetricValuesByRange = async ({
  patientId,
  metricType,
  startDate,
  endDate,
}: GetMetricValuesByRangeProps): Promise<GraphData[]> => {
  const { data } = await apiMetrics.get(
    `/metrics/getMetricValuesByRange/${patientId}/${metricType}/${formatISO(
      startDate,
    )}/${formatISO(endDate)}`,
  );

  return data;
};
